export default __webpack_public_path__ + "static/media/MyJournal.62515d46a05db702296038f55dab4b08.webp";